import { atom } from 'recoil';

export const stepState = atom({
  key: 'stepState',
  default: 1,
});
